import { TextField } from '@mui/material';
import AnnotationColorRadioGroup from '../AnnotationColor/RadioGroup';
import { HighlightColor } from '../../types';
import { useAnnotationFormContext } from './FormContext';
import { useAnnotationDialogsContext } from '../../AnnotationDialogsContext';
import { useEffect, useRef } from 'react';

export default function FormContent() {
  const { formData, updateFormData } = useAnnotationFormContext();
  const noteFieldRef = useRef<HTMLInputElement>(null);
  const { editDialogFocusTarget } = useAnnotationDialogsContext();

  useEffect(() => {
    if (editDialogFocusTarget === 'note') {
      noteFieldRef.current?.focus();
    }
  }, [editDialogFocusTarget]);

  const handleColorChange = (color: HighlightColor) => {
    updateFormData({ highlightColor: color });
  };

  const handleNoteChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    updateFormData({ note: event.target.value ?? null });
  };

  return (
    <>
      <TextField
        inputRef={noteFieldRef}
        margin='dense'
        id='annotationComment'
        name='annotationComment'
        label={'Merkintä'}
        type='text'
        fullWidth
        variant='outlined'
        multiline
        rows={8}
        value={formData.note}
        onChange={handleNoteChange}
      />
      <AnnotationColorRadioGroup
        color={formData.highlightColor}
        onChange={handleColorChange}
      />
    </>
  );
}
